import {
  AfterViewInit, Component, EventEmitter, OnDestroy, OnInit,
  Output,
  ViewChild, ViewContainerRef
} from '@angular/core';

import { Subscription } from 'rxjs';
import { DateUtils } from 'src/app/utils/date-utils';
import { AppComponent } from 'src/app/app.component';
import { MainComponent } from '../../main/main.component';
import { environment } from 'src/environments/environment';

import { MapComponent, MapMarker } from 'movisat-maps';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';

import { SsoService } from 'src/app/services/sso/sso.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { PositionService } from 'src/app/services/positions/position.service';
import { ResourcesService } from 'src/app/services/resources/resources.service';

import { MovilModel } from 'src/app/services/resources/models/movil.model';
import { PosicionModel } from 'src/app/services/positions/models/posicion.model';
import { MovilesInterface } from 'src/app/services/resources/interfaces/moviles.interface';
import { PosicionesInterface } from 'src/app/services/positions/interfaces/posiciones.interface';

import { TracksComponent } from '../../tracks/tracks.component';
import { SubflotasComponent } from '../../flota/subflotas/subflotas.component';
import { ItinerariComponent } from '../../maps-tools/itinerari/itinerari.component';
import { MovilesCercaComponent } from '../../flota/moviles-cerca/moviles-cerca.component';

@Component({
  selector: 'app-moviles',
  templateUrl: './moviles.component.html',
  styleUrls: ['./moviles.component.css']
})
export class MovilesComponent implements OnInit, AfterViewInit, OnDestroy, MovilesInterface, PosicionesInterface {
  @ViewChild('movilesContainer', { read: ViewContainerRef }) movilesContainer;
  @ViewChild('gridMovil') gridMovil: jqxGridComponent;

  // Disparadores para notificar eventos
  @Output() navegarMovilEmiter: EventEmitter<MovilModel> = new EventEmitter();

  private static instance: MovilesComponent;
  public environment = environment;
  private movilesIdx = new Map<number, number>();
  public movilesList: MovilModel[] = [];
  private movilSelec: MovilModel = null;
  private searchText = '';
  private timerSearch = null;
  private timerInfoGeo = null;
  private orderBy = 'conectado,desc';
  private map: MapComponent;
  private subcriptionNewMovil: Subscription = null;
  private subcriptionChangeMovil: Subscription = null;
  private subcriptionPosicionReady: Subscription = null;
  private subcriptionNewPosicion: Subscription = null;
  private subcriptionChangePosicion: Subscription = null;
  private subcriptionChangeFilter: Subscription = null;
  private initialFilter: any = null;
  private distCerca = 0;
  private oldFilter: any = null;
  private dataSource = {};
  public dataAdapter = new jqx.dataAdapter(this.dataSource);
  oldSortColumn: any = null;
  oldSortDirection: any = null;
  initialSort: any = null;
  isSorting: boolean = false;

  public columns = [
    {
      text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', width: 1, hidden: true
    },
    {
      text: 'Co', columntype: 'checkbox', filtertype: 'textbox', datafield: 'conectado', width: 40, hidden: true,
      // aggregates: [{
      //   'Conectados': function (aggregatedValue, currentValue: number) {
      //     return currentValue ? aggregatedValue + 1 : aggregatedValue;
      //   }
      // }],
      // aggregatesrenderer: function (aggregates) {
      //   let renderstring = '';
      //   if (aggregates["Conectados"] !== undefined) {
      //     renderstring = '<div style="text-align: center;">' + aggregates["Conectados"] + '</div>';
      //   }
      //   return renderstring;
      // }
    },
    {
      text: 'Ig', columntype: 'checkbox', filtertype: 'textbox', datafield: 'ignicion', width: 40, hidden: true
      // aggregates: [{
      //   'ConIgnicion': function (aggregatedValue, currentValue: number) {
      //     return currentValue ? aggregatedValue + 1 : aggregatedValue;
      //   }
      // }],
      // aggregatesrenderer: function (aggregates) {
      //   let renderstring = '';
      //   if (aggregates["ConIgnicion"] !== undefined) {
      //     renderstring += '<div style="text-align: center;">' + aggregates["ConIgnicion"];
      //   }
      //   return renderstring;
      // }
    },
    {
      text: 'Co', columntype: 'image', datafield: 'imagenCon', width: 25, cellsrenderer: this.imageRendererConnectado,
      aggregates: [{
        'Conectados': function (aggregatedValue: any, currentValue: any, column: number, record: any) {
          return record.conectado > 0 ? aggregatedValue + 1 : aggregatedValue;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Conectados"] !== undefined) {
          renderstring = '<div style="text-align: center;">' + aggregates["Conectados"] + '</div>';
        }
        return renderstring;
      }
    },
    {
      text: 'Ig', columntype: 'image', datafield: 'imagenIgni', width: 25, cellsrenderer: this.imageRendererIgnicion,
      aggregates: [{
        'ConIgnicion': function (aggregatedValue: any, currentValue: any, column: number, record: any) {
          return record.ignicion > 0 ? aggregatedValue + 1 : aggregatedValue;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["ConIgnicion"] !== undefined) {
          renderstring += '<div style="text-align: center;">' + aggregates["ConIgnicion"];
        }
        return renderstring;
      }
    },
    { text: 'Cod', columntype: 'textbox', filtertype: 'textbox', datafield: 'codigo', width: 45, align: 'center', cellsalign: 'center', hidden: true },
    {
      text: AppComponent.translate('Descripcion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 120,
      aggregates: [{
        'Total': function (aggregatedValue: any, currentValue: number) {
          return currentValue ? aggregatedValue + 1 : aggregatedValue;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: center;">' + aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    },
    { text: AppComponent.translate('Subflota'), columntype: 'textbox', filtertype: 'textbox', datafield: 'subflota', width: 80 },
    { text: AppComponent.translate('Tipo'), columntype: 'textbox', filtertype: 'textbox', datafield: 'tipo', width: 35 },
    { text: AppComponent.translate('Recurso'), columntype: 'textbox', filtertype: 'textbox', datafield: 'recurso', width: 80 },
    { text: AppComponent.translate('Clase'), columntype: 'textbox', filtertype: 'textbox', datafield: 'clase', width: 80 },
    { text: AppComponent.translate('Vel'), columntype: 'textbox', filtertype: 'textbox', datafield: 'velocidad', width: 40, align: 'center', cellsalign: 'center' },
    { text: AppComponent.translate('Desde'), columntype: 'date', filtertype: 'textbox', datafield: 'fecha', width: 140, cellsformat: 'dd/MM/yy HH:mm:ss' },
    { text: AppComponent.translate('Informacion_geografica'), columntype: 'textbox', filtertype: 'textbox', datafield: 'infoGeo', width: 300 },
    {
      text: AppComponent.translate('Distancia'), columntype: 'textbox', filtertype: 'textbox', datafield: 'distancia', width: 100,
      hidden: true, align: 'center', cellsalign: 'center',
      aggregates: [{
        'Cerca': function (aggregatedValue: any, currentValue: number, column: number, record: any) {
          let val = undefined;
          if (record['distancia']) {
            const v = record['distancia'].replace(',', '.').replace('km', '').replace('m', '').replace(' ', '');
            val = record['distancia'].indexOf('km') > -1 ? Number.parseFloat(v) * 1000 : Number.parseFloat(v);
          }
          return val <= MovilesComponent.getInstance().distCerca ? aggregatedValue + 1 : aggregatedValue;
        }
      },
      {
        'Lejos': function (aggregatedValue: any, currentValue: number, column: number, record: any) {
          let val = undefined;
          if (record['distancia']) {
            const v = record['distancia'].replace(',', '.').replace('km', '').replace('m', '').replace(' ', '');
            val = record['distancia'].indexOf('km') > -1 ? Number.parseFloat(v) * 1000 : Number.parseFloat(v);
          }
          return val > MovilesComponent.getInstance().distCerca ? aggregatedValue + 1 : aggregatedValue;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Cerca"] !== undefined) {
          renderstring += '<div style="text-align: center;">' + aggregates["Cerca"] + '/' + aggregates["Lejos"] + '</div>';
        }
        return renderstring;
      },
      cellsrenderer: (row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any) => {
        if (value) {
          const v = value.replace(',', '.').replace('km', '').replace('m', '').replace(' ', '');
          const val = value.indexOf('km') > -1 ? Number.parseFloat(v) * 1000 : Number.parseFloat(v);
          if (val <= this.distCerca) {
            return '<div style="text-align: center; margin-top: 4px; background-color: #93fc93;">' + value + '</div>';
          }
        }
        return '<div style="text-align: center; margin-top: 4px; background-color: #F96a6a;">' + value + '</div>';
      },
      rendergridrows: (params => {
        const data = generatedata(params.startindex, params.endindex);
        return "";
      }),
    },
    {
      text: AppComponent.translate('Navegar'), datafield: 'navegar', columntype: 'button', width: 70, hidden: true,
      cellsrenderer: (row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any): string => {
        return '>';
      },
      buttonclick: (row: number): void => {
        const dataRecord: any = this.gridMovil.getrowdata(row);
        const movil = this.movilesList[this.movilesIdx.get(dataRecord.codigo)];
        // Notifico que quiero navegar desde este móvil a algún otro sitio
        this.navegarMovilEmiter.emit(movil);
      }
    },
    { text: 'Selec', columntype: 'textbox', filtertype: 'textbox', datafield: 'selec', hidden: true, width: 1 }
  ];

  // Pongo por defecto los textos en los controles del grid en español
  public langGrid = JqWidgets.getLocalization('es');

  constructor(
    private ssoService: SsoService,
    private resourcesService: ResourcesService,
    private positionService: PositionService,
    private configService: ConfigService
  ) {
    MovilesComponent.instance = this;
  }

  async ngOnInit(): Promise<void> {
    // Cargo el idioma para los componentes jqwidgets
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
    // Me subscribo para saber cuando se han cargado las posiciones de todos los móviles
    this.subcriptionPosicionReady = this.positionService.subscribeOnPositionReady(this);
    // Recupero el filtro almacenado si lo hay
    await this.getInitFilter();
    await this.getInitSort();
  }

  ngAfterViewInit(): void {
    this.initSearchControl();
    this.initToolbarButtons();
    // Espera a que el mapa esté listo
    const interval = setInterval(async () => {
      this.map = MainComponent.getInstance().getMap();
      if (this.map) {
        clearInterval(interval);
        // Me subscribo a eventos del mapa
        this.map.subscribeOnMarkerClick(this, this.onMarkerClick);
      }
    }, 1000);
  }

  public static getInstance(): MovilesComponent {
    return MovilesComponent.instance;
  }

  // Para traducir los textos del template
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  imageRendererConnectado(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    return rowdata.conectado > 0 ? '<img style="margin-left: 4px; margin-top: 2px;" height="16" width="16" src="assets/images/conectado.png" />' :
      '<img style="margin-left: 4px; margin-top: 2px;" height="16" width="16" src="assets/images/desconectado.png" />';
  }

  imageRendererIgnicion(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    return rowdata.ignicion > 0 ? '<img style="margin-left: 4px; margin-top: 2px;" height="16" width="16" src="assets/images/ignicion1.png" />' :
      '<img style="margin-left: 4px; margin-top: 2px;" height="16" width="16" src="assets/images/ignicion0.png" />';
  }

  onMarkerClick(component: any, marker: MapMarker) {
    // Compruebo que se trata de un móvil
    if (marker.dataModel.hasOwnProperty('Ignicion')) {
      // Busco el elemento en el grid y lo selecciono
      const rows = component.gridMovil.getrows();
      if (rows) {
        rows.forEach((row, i) => {
          if (row.id === marker.dataModel.MovilId) {
            component.gridMovil.ensurerowvisible(i);
            const event = {
              args: {
                rowindex: row.dataindex ? row.dataindex : row.boundindex,
                fromCarto: true
              }
            }
            component.onRowClick(event);
          }
        });
      }
    }
  }

  // Inicializa el control de búsqueda de la cabecera
  initSearchControl(): void {
    const searchControl = document.getElementById('searchControl');
    if (searchControl) {
      searchControl.addEventListener('input', (event: any) => {
        this.searchText = event.target.value.toUpperCase();
      });
      let lastSearch = '';
      // Cada segundo compruebo si se ha filtrado la información
      this.timerSearch = setInterval(() => {
        if (this.searchText !== lastSearch) {
          lastSearch = this.searchText;
          // Marco los registros que cumplen la condición de búsqueda y pongo el campo
          // oculto a "selec"
          this.movilesList.forEach(movil => {
            if (("" + movil.Codigo).indexOf(this.searchText) > -1 ||
              (movil.Nombre && movil.Nombre.toUpperCase().indexOf(this.searchText) > -1) ||
              (movil.Matricula && movil.Matricula.toUpperCase().indexOf(this.searchText) > -1) ||
              (movil.ConjuntoVehiculo && movil.ConjuntoVehiculo.Recurso && movil.ConjuntoVehiculo.Recurso.Nombre &&
                movil.ConjuntoVehiculo.Recurso.Nombre.toUpperCase().indexOf(this.searchText) > -1) ||
              (movil.Clase && movil.Clase.Nombre && movil.Clase.Nombre.toUpperCase().indexOf(this.searchText) > -1) ||
              (movil.Subflota && movil.Subflota.Nombre.toUpperCase().indexOf(this.searchText) > -1) ||
              (movil.ultimaPos && movil.ultimaPos.Velocidad && ('' + movil.ultimaPos.Velocidad).toUpperCase().
                indexOf(this.searchText) > -1) ||
              (movil.ultimaPos && movil.ultimaPos.Fecha && DateUtils.formatDateTimeShort(movil.ultimaPos.Fecha, true).
                toUpperCase().indexOf(this.searchText) > -1) ||
              (movil.ultimaPos && movil.ultimaPos.Localizacion && movil.ultimaPos.Localizacion.Label.toUpperCase().
                indexOf(this.searchText) > -1)) {
              movil.selec = 'selec';
            } else {
              movil.selec = '';
            }
          });
          // Compruebo si ya he creado el filtro "selec" anteriormente
          const filters = this.gridMovil.getfilterinformation();
          if (filters.find(s => s.datafield === 'selec') === undefined) {
            const filtergroup = new jqx.filter();
            filtergroup.addfilter(1, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
            this.gridMovil.addfilter('selec', filtergroup);
          }
          this.gridMovil.applyfilters();
          this.gridMovil.updatebounddata('data');
        }
      }, 1000);
    }
  }

  // Cuando se refrescan los datos del grid
  onBindingComplete() {
    const orderParameters = this.orderBy.split(',');
    if (this.gridMovil && this.movilesList && this.movilesList.length > 0) {
      this.isSorting = true; // Antes de ordenar, marca que estás en medio de una ordenación

      // Ordenar por 'conectado' primero
      this.gridMovil.sortby(orderParameters[0], orderParameters[1]);

      // Si el usuario ha establecido un campo y una dirección de ordenación
      if (orderParameters.length > 2) {
        this.gridMovil.sortby(orderParameters[2], orderParameters[3]);
      }

      this.isSorting = false; // Una vez que la ordenación se completa, desmarca que estás en medio de una ordenación
    }

    if (this.initialFilter) {
      this.setStoredFilter();
    }
    // Si no está el reproductor de ruta abierto me aseguro que todos los móviles del
    // grid se visualizan en en la cartogafía y quito los que no están visibles
    if (!TracksComponent.instance) {
      const rowsVisibles = this.gridMovil.getrows();
      if (rowsVisibles) {
        const movilesVisibles = new Map<number, number>();
        rowsVisibles.forEach(row => {
          movilesVisibles.set(row.codigo, row.codigo);
        });
        if (this.movilesList) {
          this.movilesList.forEach(movil => {
            if (movil.marker) {
              movil.marker.setVisible(movilesVisibles.get(movil.Codigo) !== undefined);
            }
          });
        }
      }
    }

    const t = setTimeout(() => {
      clearTimeout(t);
      this.gridMovil.autoresizecolumns();
    }, 500);
  }

  // Cuando se destruye el componente borro las subscripciones y los temporizadores
  ngOnDestroy() {
    if (this.timerSearch === null) {
      clearInterval(this.timerSearch);
    }
    if (this.timerInfoGeo === null) {
      clearInterval(this.timerInfoGeo);
    }
    if (this.subcriptionNewMovil !== null) {
      this.subcriptionNewMovil.unsubscribe();
    }
    if (this.subcriptionChangeMovil !== null) {
      this.subcriptionChangeMovil.unsubscribe();
    }
    if (this.subcriptionPosicionReady !== null) {
      this.subcriptionPosicionReady.unsubscribe();
    }
    if (this.subcriptionNewPosicion !== null) {
      this.subcriptionNewPosicion.unsubscribe();
    }
    if (this.subcriptionChangePosicion !== null) {
      this.subcriptionChangePosicion.unsubscribe();
    }
    if (this.subcriptionChangeFilter !== null) {
      this.subcriptionChangeFilter.unsubscribe();
    }
  }

  // Cuando se selecciona una fila
  onRowClick(event: any) {
    const rowSel = this.gridMovil.getselectedrowindexes();
    if (rowSel && rowSel.length < 2) {
      this.gridMovil.clearselection();
      this.gridMovil.selectrow(event.args.rowindex);
    }
    this.movilSelec = this.movilesList[event.args.rowindex];
    if (this.movilSelec.marker !== undefined) {
      if (!event.args.fromCarto) {
        this.movilSelec.marker.map.setCenter(this.movilSelec.marker.position);
        this.movilSelec.marker.animate(3000);
      }
    }
  }

  // Cuando se crea un móvil nuevo
  onNewMovil(movil: MovilModel) {
    // Añado el móvil a la lista
    this.movilesIdx.set(movil.Codigo, this.movilesList.length);
    this.movilesList.push(movil);
  }

  // Cuando cambia la información de un móvil
  onChangeMovil(movil: MovilModel) {
    // Actualizo los datos del móvil en la lista
    this.movilesList[this.movilesIdx.get(movil.Codigo)] = movil;
  }

  // Cuando se han terminado de recuperar las posiciones de todos los móviles
  async onPosicionesReady() {
    // Cargo la lista de móviles y me subscribo para recibir los cambios
    await this.getMoviles();
    this.subcriptionNewMovil = this.resourcesService.subscribeNewMoviles(this);
    this.subcriptionChangeMovil = this.resourcesService.subscribeChangeMoviles(this);
    this.subcriptionChangeFilter = this.resourcesService.changeFilterEmiter.subscribe(async () => {
      await this.getMoviles();
      this.gridMovil.updatebounddata('data');
      MainComponent.getInstance().createMarkerPos();
    });
    // Me subscribo para recibir los cambios en las posiciones de los móviles
    this.subcriptionNewPosicion = this.positionService.subscribeNewPosition(this);
    this.subcriptionChangePosicion = this.positionService.subscribeChangePosition(this);
    // Actualizo el grid cada x tiempo para que se actualicen la información geográfica
    this.timerInfoGeo = setInterval(() => {
      this.gridMovil.updatebounddata('data');
    }, environment.refresInfoGeoInterval);
  }

  async getMoviles() {
    let filterIA: any = await this.configService.getEmp('moviles-IA', null);
    if (filterIA) {
      filterIA = JSON.parse(filterIA);
    }
    // Cargo la lista de móviles
    this.movilesList = await this.resourcesService.getMoviles();
    this.movilesList.forEach((movil, index) => {
      this.movilesIdx.set(movil.Codigo, index);
    });
    // Configuro el grid
    this.dataSource = {
      datatype: 'json',
      datafields: [
        { name: 'id', map: 'Codigo' },
        { name: 'conectado', map: 'Conectado' },
        { name: 'ignicion', map: 'Ignicion' },
        { name: 'codigo', map: 'Codigo' },
        { name: 'nombre', map: 'Nombre' },
        { name: 'subflota', map: 'Subflota>Nombre' },
        { name: 'tipo', map: 'TipoMovil>Acronimo' },
        { name: 'recurso', map: 'ConjuntoVehiculo>Recurso>Nombre' },
        { name: 'clase', map: 'Clase>Nombre' },
        { name: 'velocidad', map: 'ultimaPos>Velocidad' },
        { name: 'fecha', map: 'ultimaPos>Fecha' },
        { name: 'infoGeo', map: 'ultimaPos>Localizacion>Label' },
        { name: 'distancia', map: 'distancia' },
        { name: 'selec', map: 'selec' }
      ],
      localdata: this.movilesList,
      // sortcolumn: 'conectado',
      // sortdirection: 'desc'
    };
    this.dataAdapter = new jqx.dataAdapter(this.dataSource);
  }

  onNewPosicion(posicion: PosicionModel) {
  }

  onChangePosicion(posicion: PosicionModel) {
  }

  // Crea los componentes de la cabecera
  createToolBar(statusbar: any) {
    if (statusbar[0] !== undefined) {
      // Añado el control de búsqueda a la cabecera
      const toolbarContainer = document.createElement('div');
      toolbarContainer.style.cssText = 'overflow: hidden; position: relative; margin-left: 4px; margin-top: 0px';
      const searchControl: any = document.createElement('div');
      searchControl.id = 'searchControl';
      searchControl.style.cssText = `
        float: left;
        background-color: white;
        background-image: url('../assets/images/search.png');
        background-repeat: no-repeat;
        background-position: 4px center;
        background-size: 18px;
        display: flex;
        align-items: center;
        width: 206px;
        margin-top: 2px;
        padding-top: 2px;
        padding-left: 28px;
        height: 25px;
        border: 1px solid rgba(0, 0, 0, 0.5);
        border-radius: 3px;
        overflow: hidden;
      `;
      searchControl.innerHTML = '<input type="text" style="border: 0;width: 100%; outline: none;" (keydown.enter)="$event.preventDefault()" ' +
        'placeholder="' + AppComponent.translate('Buscar') + '..." autocorrect = "off" autocapitalize = "off" spellcheck = "off">';
      toolbarContainer.appendChild(searchControl);
      // Creo el botón para reproducir rutas
      const btnSubflotas: any = document.createElement('div');
      btnSubflotas.id = 'btnSubflotas';
      btnSubflotas.style.cssText = 'float: left; height: 25px; width: 105px; padding-left: 3px; padding-top: 2px;';
      btnSubflotas.innerHTML = `
        <button type="submit" style="width: 100px; height: 25px; align-items: center;">
        <div style="float: right; padding-top: 2px;">`+ AppComponent.translate('Subflotas') + `</div>
        <img style="float: left; height: 18px; width: 18px;" src="../assets/images/subflota.png" /></button>
      `;
      toolbarContainer.appendChild(btnSubflotas);
      // Creo el botón para reproducir rutas
      const btnRutaControl: any = document.createElement('div');
      btnRutaControl.id = 'btnRecorrido';
      btnRutaControl.style.cssText = 'float: left; height: 25px; width: 110px; padding: 2px;';
      btnRutaControl.innerHTML = `
        <button type="submit" style="width: 110px; height: 25px; align-items: center;">
        <div style="float: right; padding-top: 2px;">`+ AppComponent.translate('Recorridos') + `</div>
        <img style="float: left; height: 18px; width: 18px;" src="../assets/images/route.png" /></button>
      `;
      toolbarContainer.appendChild(btnRutaControl);

      // Creo el botón para móviles cercanos
      const btnMovilesCerca: any = document.createElement('div');
      btnMovilesCerca.id = 'btnMovilesCerca';
      btnMovilesCerca.style.cssText = 'float: left; height: 25px; width: 75px; margin-left: 4px; padding: 2px;';
      btnMovilesCerca.innerHTML = `
        <button type="submit" style="width: 75px; height: 25px; align-items: center;">
        <div style="float: right; padding-top: 2px;">`+ AppComponent.translate('Cerca') + `</div>
        <img style="float: left; height: 18px; width: 18px;" src="../assets/images/radar.png" /></button>
      `;
      toolbarContainer.appendChild(btnMovilesCerca);
      // Creo el botón para itinerarios
      const btnItinerari: any = document.createElement('div');
      btnItinerari.id = 'btnItinerari';
      btnItinerari.style.cssText = 'float: left; height: 25px; width: 110px; margin-left: 4px; padding: 2px;';
      btnItinerari.innerHTML = `
        <button type="submit" style="width: 110px; height: 25px; align-items: center;">
        <div style="float: right; padding-top: 2px;">`+ AppComponent.translate('Itinerarios') + `</div>
        <img style="float: left; height: 18px; width: 18px;" src="../assets/images/itinerary.png" /></button>
      `;
      toolbarContainer.appendChild(btnItinerari);

      statusbar[0].appendChild(toolbarContainer);
    }
  }
  //devuelve una lista de elementos moviles que es llamado en el componente track.ts
  getListMoviles(): MovilModel[] {
    const movilesSelec: MovilModel[] = [];
    const rowsSelec = this.gridMovil.getselectedrowindexes();
    if (rowsSelec && rowsSelec.length > 0) {
      if (rowsSelec.length < 6) {
        rowsSelec.forEach(rowIndex => {
          movilesSelec.push(this.movilesList[rowIndex]);
        });
      }
      else {
        MainComponent.getInstance().showWarning('ATENCION', 'Cinco_moviles_maximo', 3000);
        return null
      }
    }
    return movilesSelec;
  }
  // Inicializa los botones de la cabecera
  initToolbarButtons(): void {
    const btnRoute = document.getElementById('btnRecorrido');
    if (btnRoute) {
      btnRoute.addEventListener('click', (event: any) => {
        // Sólo puede haber un reproductor abierto
        // if (!TracksComponent.instance) {
        // Recupero los móviles selecionados
        const rowsSelec = this.gridMovil.getselectedrowindexes();
        if (rowsSelec && rowsSelec.length > 0) {
          if (rowsSelec.length < 6) {
            const movilesSelec: MovilModel[] = [];
            rowsSelec.forEach(rowIndex => {
              movilesSelec.push(this.movilesList[rowIndex]);

            });
            // Obtengo las filas filtradas para que el reproductor pueda ocultar y luego volver a poner
            // visibles sólo los móviles filtrados
            const movilesVisibles: MovilModel[] = [];
            let rowsVisibles = this.gridMovil.getrows();
            if (rowsVisibles) {
              rowsVisibles.forEach(row => {
                movilesVisibles.push(this.movilesList[this.movilesIdx.get(row.codigo)]);
              });
            }
            // Creo el componente y le paso los móviles seleccionados, también le paso los filtrados en ese momento
            const component = this.movilesContainer.createComponent(TracksComponent);
            component.instance.init(component, movilesSelec, movilesVisibles);
          } else {
            MainComponent.getInstance().showWarning('ATENCION', 'Cinco_moviles_maximo', 3000);
          }
        } else {
          MainComponent.getInstance().showInfo('ATENCION', 'Seleccione_movil', 3000);
        }
        // } else {
        //   MainComponent.getInstance().showInfo('ATENCION', 'Reproductor_abierto', 3000);
        // }
      });
    }
    const btnSubflota = document.getElementById('btnSubflotas');
    if (btnSubflota) {
      btnSubflota.addEventListener('click', (event: any) => {
        const component = this.movilesContainer.createComponent(SubflotasComponent);
        component.instance.init(component);
      });
    }
    const btnMovilesCerca = document.getElementById('btnMovilesCerca');
    if (btnMovilesCerca) {
      btnMovilesCerca.addEventListener('click', (event: any) => {
        const component = this.movilesContainer.createComponent(MovilesCercaComponent);
        component.instance.init(component, 0);
      });
    }
    const btnItinerari = document.getElementById('btnItinerari');
    if (btnItinerari) {
      btnItinerari.addEventListener('click', (event: any) => {
        const component = this.movilesContainer.createComponent(ItinerariComponent);
        component.instance.init(component, 0);
      });
    }
  }

  // Cando se crea un filtro
  async onChangeFilter(event: any) {

    this.initialFilter = null;
    let filter = null;
    // Si el primer filtro es el de la búsqueda busco el siguiente filtro
    let columnFilter = event.args.filters[0] ? event.args.filters[0].datafield : '';
    if (columnFilter === 'selec') {
      if (event.args.filters[1]) {
        // Si hay un segundo filtro es por que se han filtrado por alguna columna
        columnFilter = event.args.filters[1].datafield
        filter = event.args.filters[1].filter.getfilters();
      }
    } else {
      filter = event.args.filters[0] ? event.args.filters[0].filter.getfilters() : null;
    }
    // Si ha cambiado el filtro
    if (this.oldFilter !== filter) {
      this.oldFilter = filter;
      // Si no hay filtro pongo la variable en blanco
      if (!filter) {
        // Guardo la variable de configuración en blanco
        this.configService.setUsuEmpApp('moviles-filters', '');
      } else {
        const config = {
          column: columnFilter,
          filters: filter
        }
        // Guardo la variable de configuración con los datos del filtro
        this.configService.setUsuEmpApp('moviles-filters', JSON.stringify(config));
      }
      // Para que se repinten los cluster
      this.onBindingComplete();
    }
  }

  // '{"column":"subflota","filters":[{"value":"C.Lateral","condition":"EQUAL","operator":1,"type":"stringfilter"}]}'
  setStoredFilter() {
    // Recupero los datos del filtro guardado y los aplico
    const filtergroup = new jqx.filter();
    if (this.initialFilter && this.initialFilter.filters) {
      this.initialFilter.filters.forEach(elem => {
        const filter = filtergroup.createfilter(elem.type, elem.value, elem.condition);
        filtergroup.addfilter(elem.operator, filter);
      });
      this.gridMovil.addfilter(this.initialFilter.column, filtergroup);
      this.gridMovil.applyfilters();
      this.initialFilter = null;
    }
  }

  // Recupero el filtro guardado si lo hay
  async getInitFilter() {
    this.initialFilter = await this.configService.getUsuEmpApp('moviles-filters', null);
    if (this.initialFilter) {
      this.initialFilter = JSON.parse(this.initialFilter);
    }
  }

  async getInitSort() {
    const storedSort: any = await this.configService.getUsuEmpApp('moviles-sort', null);
    if (storedSort) {
      const sortConfig = JSON.parse(storedSort);
      if (sortConfig.column === null) {
        this.setOrderBy('nombre', 'desc');
      } else {
        this.setOrderBy(sortConfig.column, sortConfig.direction);
      }
    }
  }

  onSort(event: any) {
    if (this.isSorting) {
      // Si estamos en medio de una ordenación, no hagas nada
      return;
    }
    // Asume que `event.args.sortinformation.sortcolumn` es el campo de orden y `event.args.sortinformation.sortdirection.ascending` indica si es ascendente
    let userField = event.args.sortinformation.sortcolumn;
    let userDirection = event.args.sortinformation.sortdirection.ascending ? 'asc' : 'desc';

    // si se quita la ordenación, establece el orden predeterminado
    if (event.args.sortinformation.sortdirection.ascending === false && event.args.sortinformation.sortdirection.descending === false) {
      this.orderBy = 'conectado,desc';
      this.onBindingComplete();
      return;
    }

    // Actualizar orderBy para mantener 'conectado' como primer criterio de orden
    this.setOrderBy(userField, userDirection);

    // Crea la configuración de ordenación
    const sortConfig = {
      column: userField,
      direction: userDirection
    }
    // Guarda la configuración de ordenación
    this.configService.setUsuEmpApp('moviles-sort', JSON.stringify(sortConfig));

    // Rehacer el enlace de datos después de cambiar la orden
    this.onBindingComplete();
  }


  setOrderBy(field: string, direction: string) {
    this.orderBy = `conectado,desc,${field},${direction}`;
  }

  // Permite refrescar el grid de móviles
  public async refreshGrid() {
    setTimeout(() => {
      this.gridMovil.updatebounddata('data');
      this.gridMovil.ensurerowvisible(0);
    }, 500);
  }

  // Permite modificar la columna de ordenación y la dirección
  public async orderGridBy(column: string, order: string) {
    setTimeout(() => {
      this.orderBy = column + ',' + order;
      this.gridMovil.updatebounddata('cell');
      this.gridMovil.ensurerowvisible(0);
    }, 500);
  }

  // Permite visualizar u ocultar columnas del grid
  public showColumnGrid(column: string, show: boolean) {
    if (show) {
      this.gridMovil.showcolumn(column);
    } else {
      this.gridMovil.hidecolumn(column);
    }
  }

  // Permite asignar la distancia a la que se buscan móviles cerca
  public setDistanciaCerca(distancia: number) {
    this.distCerca = distancia;
  }

}
